<template>
  <el-card class="modelLineChart-container" :body-style="{ padding: '0px' }">
    <div class="modelLineChart-main">
      <div class="modelLineChart-main-header">
        <p>{{ chartData.title }}</p>
        <!-- <p>书城模块</p>
        <p>点击量</p> -->
      </div>
      <div ref="modelLineChart" style="width: 100%;height:500px;"></div>
      <slot></slot>
    </div>
    <!-- card body -->
  </el-card>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    chartData: {
      type: Object
    },
    lineColor: {
      type: String,
      default: "#5493fa"
    }
  },
  data() {
    return {
      myChart: null,
      options: {
        legend: {
          data: []
        },
        tooltip: {
          trigger: "axis", // 提示类型 'item'
          // formatter: "{b0}<br />{a} {c0}",
          backgroundColor: "#fff",
          textStyle: {
            color: "#a1a2af",
            fontWeight: "bold"
          },
          borderColor: "#DCDFE6",
          borderWidth: 1
          // axisPointer: {
          //   type: "cross"
          // }
          // backgroundColor: "rgba(245, 245, 245, 0.8)",
          // borderWidth: 1,
          // borderColor: "#ccc",
          // padding: 10,
          // textStyle: {
          //   color: "#000"
          // },
          // position: function(pos, params, el, elRect, size) {
          //   var obj = { top: 10 };
          //   obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
          //   return obj;
          // },
          // extraCssText: "width: 170px"
        },
        grid: {
          show: false,
          left: "3%",
          right: "3%",
          top: "10%",
          containLabel: true
        },
        // toolbox: {
        //     show:true,
        //     feature: {
        //         dataView: {readOnly: false},
        //     }
        // },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [],
            axisLine: {
              show: true
            },
            axisTick: {
              show: true
            },
            axisLabel: {
              color: "#a1a2af",
              interval: 0, // 全部显示
              rotate: 65
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            scale: true,
            // name: '点击量',
            // max: 100,
            min: 0,
            boundaryGap: [0.2, 0.2],
            // interval: 15,
            minInterval: 1,

            axisLine: {
              show: true
            },
            axisTick: {
              show: true
            },
            axisLabel: {
              color: "#a1a2af"
            },
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed"
              }
            }
          }
        ],
        series: [
          // {
          //   name: "",
          //   type: "line",
          //   smooth: false,
          //   data: [],
          //   itemStyle: {
          //     // opacity: 0.1,
          //     // borderWidth:2,
          //     borderColor: this.lineColor
          //   },
          //   lineStyle: {
          //     color: this.lineColor,
          //     width: 3,
          //     shadowColor: "rgba(0, 0, 0, 0.5)",
          //     shadowBlur: 10,
          //     shadowOffsetY: 5
          //   },
          //   areaStyle: {
          //     color: "#c2c9ea",
          //     opacity: 0.1
          //   }
          // }
        ]
      }
    };
  },
  methods: {
    chartResize() {
      this.myChart.resize({ width: "auto" });
    },
    initChart() {
      this.myChart ? this.myChart.clear() : "";
      this.myChart = echarts.init(this.$refs.modelLineChart);
      this.options.xAxis[0].data = this.chartData.date;
      this.options.series = [];
      this.options.legend.data = [];
      this.chartData.count.forEach((item, index) => {
        this.options.series[index] = {
          name: item.model,
          type: "line",
          data: item.data
        };
        this.options.legend.data[index] = item.model;
      });
      this.myChart.setOption(this.options);
    }
  },

  watch: {
    chartData() {
      this.initChart();
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.chartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.chartResize);
  }
};
</script>

<style lang="scss" scoped>
.modelLineChart-container {
  margin-bottom: 20px;
  &:last-child() {
    margin-bottom: 0;
  }
  .modelLineChart-main-header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
}
</style>
